import React from 'react';

export const Beliefs = [
	{
		id: 1,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 11,
				paragraph: [
					<p>
						Moneyfront believes in the philosophy that a ‘Happy client is your
						best advocate.’ Our priority is, thus, helping you become so
						financially secure that you forget it’s payday!
					</p>,
					<p>
						We want to help our customers attract an abundance of money into
						their life and, in the process, become their comrades.
					</p>,
				],
			},
			{
				id: 12,
				paragraph: [
					<p>
						Build the millionaire mindset – this is the mantra that our team
						abides by while servicing the client. Anyone can help with how to
						open a mutual fund account, or anyone can suggest avenues for
						investments, but we believe in reshaping the manner in which
						investors approach their money and life. If this structural shift in
						their outlook is achieved, we know we have triumphed.
					</p>,
				],
			},
		],
	},
];
